import React, {forwardRef} from "react";

// We have to use forwardRef because we want to set focus to the first
// input field once everything has been rendered. This occurs in the ultimate parent element
const Input = forwardRef((props,ref) => {
  
  const { 
      id
    , type
    , noAnimation
    , tabIndex
    , blnFullWidth
    , blnShowTick
    , txtLabel
    , txtPlaceholder
    , minLength
    , maxLength
    , blnRequired
    , imgFieldIndicator
    , onChange} = props;

  return (
    <div className={`field-container 
                  ${blnFullWidth ? "fullwidth" : "halfwidth"}
                  ${noAnimation ? "no-animation" : ""}`}>
        <span className="field-label">{txtLabel}</span>
        {
          blnShowTick ? 
          <img src={imgFieldIndicator} className="field-indicator-image" alt="Completed Tick" /> :
          <span className="field-indicator">{blnRequired ? "Required" : "Optional"} </span>
        }
        
        <input 
          id={id} 
          ref={ref}
          className="field-input" 
          type={type} 
          placeholder={txtPlaceholder}
          minLength={minLength}
          maxLength={maxLength} 
          tabIndex={tabIndex} 
          required={blnRequired ? "required" : ""} 
          onChange={onChange}/>
    </div>
  );
  
}
);

export default Input;